var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 0C5.4826 0 6.58481 0.456546 7.39746 1.2692C8.21012 2.08186 8.66667 3.18406 8.66667 4.33333C8.66667 5.40667 8.27333 6.39333 7.62667 7.15333L7.80667 7.33333H8.33333L11.6667 10.6667L10.6667 11.6667L7.33333 8.33333V7.80667L7.15333 7.62667C6.39333 8.27333 5.40667 8.66667 4.33333 8.66667C3.18406 8.66667 2.08186 8.21012 1.2692 7.39746C0.456546 6.58481 0 5.4826 0 4.33333C0 3.18406 0.456546 2.08186 1.2692 1.2692C2.08186 0.456546 3.18406 0 4.33333 0ZM4.33333 1.33333C2.66667 1.33333 1.33333 2.66667 1.33333 4.33333C1.33333 6 2.66667 7.33333 4.33333 7.33333C6 7.33333 7.33333 6 7.33333 4.33333C7.33333 2.66667 6 1.33333 4.33333 1.33333Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.ebca538bc7fa641d8d6ecbf79bb3d383.svg";
export { ForwardRef as ReactComponent };